<template>
  <ProSpaceVLayout class="store-column">
    <ProSpaceHLayout>
      <div
        class="store-column__title"
        :title="data.networkValue"
      >
        <span @click="$emit('click-on-title')">
          {{ data.networkValue }}
        </span>
      </div>
    </ProSpaceHLayout>
    <ProSpaceHLayout class="store-column__tags" :gap="2">
      <ProSpaceTag
        type="gray-light"
        :text="data[codeLabel]"
        bordered
        style="height: 18px;"
      />
      <ProSpaceTag
        :type="status.type"
        v-if="data.status"
        :text="status.text"
        style="height: 18px"
      />
    </ProSpaceHLayout>
    <div :class="['store-column__address', !wrapAddress ? 'store-column__address--nowrap' : '']" :title="data.address">
      <span>{{ data.address }}</span>
    </div>
    <div
      v-if="isStatusDisplay"
      :class="`store-column__order-status store-column__order-status--${data.orderStatus}`"
    >
      {{ $t(`order_${data.orderStatus}`) }}
    </div>
    <div class="store-column__status" v-if="isChangesDisplay">
      <div
        class="store-column__status-item"
        :class="{ 'store-column__status-item--disabled' : !data.updated }"
      >
        <ProSpaceIcon
          icon="update"
          icon-width="11px"
          icon-height="11px"
        />
        <div class="store-column__status-info">
          <span class="store-column__status-name">
            {{ $t('updated') }}
          </span>
          <span
            class="store-column__status-date"
            :title="getFormatDateTime(data.updateDate) + ' ' + getAMorPM()(data.updateDate, userinfo?.timeFormat)"
            v-if="data.updated"
          >
            {{ getFormatDate(data.updateDate) }}
          </span>
        </div>
      </div>
      <div
        class="store-column__status-item"
        :class="{ 'store-column__status-item--disabled' : !data.edited }"
      >
        <ProSpaceIcon
          icon="user-pen"
          icon-width="11px"
          icon-height="11px"
        />
        <div class="store-column__status-info">
          <span class="store-column__status-name">
            {{ $t('changed') }}
          </span>
          <span
            class="store-column__status-date"
            :title="getFormatDateTime(data.editDate) + ' ' + getAMorPM()(data.editDate, userinfo?.timeFormat)"
            v-if="data.edited"
          >
            {{ getFormatDate(data.editDate) }}
          </span>
        </div>
      </div>
    </div>
    <ProSpaceTag v-if="isApproveDisplay !== null" class="margin-top-10"
      :type="isApproveDisplay ? 'teal' : 'error'"
      :text="$t(`${isApproveDisplay ? 'adjustmentFieldAccepted' : 'adjustmentFieldDeclined'}`)"
      isBorderStyle
      style="height: 18px"
    />
  </ProSpaceVLayout>
</template>
<script>
import {
  ProSpaceHLayout,
  ProSpaceVLayout,
  ProSpaceTag,
  ProSpaceIcon
} from "@prospace/prospace-components-library";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "storeColumn",
  components: {
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceTag,
    ProSpaceIcon
  },
  props: {
    data: {
      type: Object
    },
    status: {
      type: Object
    },
    isStatusDisplay: {
      type: Boolean
    },
    isChangesDisplay: {
      type: Boolean,
      default: true
    },
    codeLabel: {
      type: String,
      default: "outletId"
    },
    isApproveDisplay: {
      type: [Boolean, null],
      default: null
    },
    wrapAddress: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
      getFormatDate: "userinfoStore/getFormatDate",
    }),
  },
  methods: {
    getAMorPM() {
      return getAMorPM
    },
    getOrderStatusName(date) {
      switch(this.data.orderStatus) {
        case 'published':

      }
    }
  }
}
</script>
<style lang="scss" scoped>
.store-column {
  height: auto !important;
  &__single {
    padding-left: 5px;
  }
  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    //color: rgba(0, 0, 0, 0.87) !important;
    color: var(--prospace-text-main);
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__tags {
    margin-top: 5px;
  }
  &__address {
    margin-top: 5px;
    display: flex;
    width: calc(100% - 10px);
    font-size: 9px;
    line-height: 11px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: break-spaces;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: var(--prospace-text-gray);
    &--nowrap {
      white-space: nowrap;
      span {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  &__order-status {
    margin-top: 10px;
    height: 17px;
    font-size: 10px;
    font-weight: 500;
    line-height: 11px;
    padding: 2px 5px;
    border: 1px solid;
    border-radius: 3px;
    color: #9B59B6;
    &--published {
      color: #9B59B6;
      border-color: #9B59B6;
    }
    &--created {
      color: #B0BEC5;
      border-color: #B0BEC5;
    }
    &--created {
      color: #B0BEC5;
      border-color: #B0BEC5;
    }
    &--approved {
      color: #5196DB;
      border-color: #5196DB;
    }
    &--completed {
      color: #1ABC9C;
      border-color: #1ABC9C;
    }
  }
  &__status {
    display: flex;
    align-items: flex-start;
    margin-top: 10px;
    &-item {
      display: flex;
      &:last-child {
        margin-left: 15px;
      }
      &--disabled {
        opacity: 0.5;
      }
    }
    &-info {
      display: flex;
      flex-direction: column;
      margin-left: 3px;
    }
    &-name {
      font-size: 9px;
      line-height: 11px;
      font-weight: 500;
      color: var(--prospace-text-gray);
    }
    &-date {
      font-size: 8px;
      line-height: 9px;
      margin-top: 3px;
      color: var(--prospace-text-gray);
    }
  }
  .p-selectable-row {
    align-items: flex-start;
  }
}
</style>
